(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var text = {
    added: 'Added to cart',
    failed: 'Could not add this item. Please try again.',
    unavailable: 'This option is unavailable.',
    soldOut: 'Sold out'
  };

  function parseVariants(root) {
    var json = root.querySelector('[data-mb-pdp-variant-json]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return [];
    }
  }

  function bindPress(el) {
    if (!el || el.dataset.mbPressReady) return;
    el.dataset.mbPressReady = '1';
    function on() { el.classList.add('is-pressed'); }
    function off() { el.classList.remove('is-pressed'); }
    el.addEventListener('pointerdown', on);
    el.addEventListener('pointerup', off);
    el.addEventListener('pointerleave', off);
    el.addEventListener('pointercancel', off);
  }

  var qtyRules = { min: 1, max: null, step: 1 };

  function clampQty(value) {
    var next = parseInt(value, 10);
    if (isNaN(next)) next = qtyRules.min;
    if (next < qtyRules.min) next = qtyRules.min;
    if (qtyRules.max != null && next > qtyRules.max) next = qtyRules.max;
    return next;
  }

  function updateQtyButtons() {
    var input = document.querySelector('[data-mb-pdp-qty-input]');
    var value = clampQty(input ? input.value : qtyRules.min);
    document.querySelectorAll('[data-mb-pdp-qty]').forEach(function (wrap) {
      var minus = wrap.querySelector('[data-mb-pdp-qty-minus]');
      var plus = wrap.querySelector('[data-mb-pdp-qty-plus]');
      if (minus) minus.disabled = value <= qtyRules.min;
      if (plus) plus.disabled = qtyRules.max != null && value >= qtyRules.max;
    });
  }

  function variantQtyRules(variant) {
    var min = 1;
    var step = 1;
    var max = null;
    var rule = variant && variant.quantity_rule;
    if (rule) {
      min = parseInt(rule.min, 10) || 1;
      step = parseInt(rule.increment, 10) || 1;
      if (rule.max != null && rule.max !== '') {
        var ruleMax = parseInt(rule.max, 10);
        if (!isNaN(ruleMax) && ruleMax > 0) max = ruleMax;
      }
    }
    if (
      variant &&
      variant.available &&
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy !== 'continue'
    ) {
      var stock = parseInt(variant.inventory_quantity, 10);
      if (!isNaN(stock) && stock >= 0) {
        max = max == null ? stock : Math.min(max, stock);
      }
    }
    if (max != null && max < min) max = min;
    return { min: min, max: max, step: step };
  }

  function applyQtyRules(variant) {
    var next = variantQtyRules(variant);
    qtyRules.min = next.min;
    qtyRules.max = next.max;
    qtyRules.step = next.step;
    document.querySelectorAll('[data-mb-pdp-qty-input]').forEach(function (input) {
      input.min = String(qtyRules.min);
      input.step = String(qtyRules.step);
      if (qtyRules.max != null) input.max = String(qtyRules.max);
      else input.removeAttribute('max');
    });
    var current = document.querySelector('[data-mb-pdp-qty-input]');
    syncQuantity(current ? current.value : qtyRules.min);
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-mb-pdp-gallery]');
    var noop = { activateByMediaId: function () { return false; } };
    if (!gallery) return noop;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-mb-pdp-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-mb-pdp-gallery-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-mb-pdp-gallery-dot]'));
    if (!slides.length) return noop;

    var current = 0;
    var prevBtn = gallery.querySelector('[data-mb-pdp-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-mb-pdp-gallery-next]');
    var thumbsEl = gallery.querySelector('[data-mb-pdp-gallery-thumbs]');
    var thumbsPrev = gallery.querySelector('[data-mb-pdp-thumbs-prev]');
    var thumbsNext = gallery.querySelector('[data-mb-pdp-thumbs-next]');

    function updateNav() {
      if (slides.length <= 1) return;
      if (prevBtn) prevBtn.hidden = current <= 0;
      if (nextBtn) nextBtn.hidden = current >= slides.length - 1;
    }

    function updateThumbScrollNav() {
      if (!thumbsEl || !thumbsPrev || !thumbsNext) return;
      var overflow = thumbsEl.scrollWidth > thumbsEl.clientWidth + 2;
      thumbsPrev.hidden = !overflow || thumbsEl.scrollLeft <= 2;
      thumbsNext.hidden = !overflow || thumbsEl.scrollLeft >= thumbsEl.scrollWidth - thumbsEl.clientWidth - 2;
    }

    function activate(index) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
      });
      var counterCurrent = gallery.querySelector('[data-mb-pdp-gallery-current]');
      if (counterCurrent) counterCurrent.textContent = String(current + 1);
      dots.forEach(function (dot, i) {
        var active = i === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      updateNav();
      window.requestAnimationFrame(updateThumbScrollNav);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(parseInt(thumb.dataset.mediaIndex, 10) || 0);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        activate(parseInt(dot.dataset.mediaIndex, 10) || 0);
      });
    });

    if (prevBtn) {
      bindPress(prevBtn);
      prevBtn.addEventListener('click', function () { activate(current - 1); });
    }
    if (nextBtn) {
      bindPress(nextBtn);
      nextBtn.addEventListener('click', function () { activate(current + 1); });
    }
    if (slides.length > 1) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = slides.length <= 1;
    }

    if (thumbsEl) {
      thumbsEl.addEventListener('scroll', updateThumbScrollNav, { passive: true });
      window.addEventListener('resize', updateThumbScrollNav);
      updateThumbScrollNav();
    }
    if (thumbsPrev && thumbsEl) {
      bindPress(thumbsPrev);
      thumbsPrev.addEventListener('click', function () {
        thumbsEl.scrollBy({ left: -Math.max(thumbsEl.clientWidth * 0.7, 180), behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    }
    if (thumbsNext && thumbsEl) {
      bindPress(thumbsNext);
      thumbsNext.addEventListener('click', function () {
        thumbsEl.scrollBy({ left: Math.max(thumbsEl.clientWidth * 0.7, 180), behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    }

    var stage = gallery.querySelector('[data-mb-pdp-gallery-stage]');
    if (stage && slides.length > 1) {
      var startX = 0;
      stage.addEventListener('touchstart', function (event) {
        startX = event.changedTouches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) < 40) return;
        activate(delta < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    updateNav();
    updateThumbScrollNav();

    var zoomDialog = document.querySelector('[data-mb-pdp-zoom-dialog]');
    var zoomImage = zoomDialog && zoomDialog.querySelector('[data-mb-pdp-zoom-image]');
    gallery.querySelectorAll('[data-mb-pdp-zoom-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (!zoomDialog || !zoomImage) return;
        zoomImage.src = trigger.dataset.zoomSrc || '';
        zoomImage.alt = trigger.dataset.zoomAlt || '';
        if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
        else zoomDialog.setAttribute('open', '');
      });
    });
    document.querySelector('[data-mb-pdp-zoom-close]')?.addEventListener('click', function () {
      if (!zoomDialog) return;
      if (typeof zoomDialog.close === 'function') zoomDialog.close();
      else zoomDialog.removeAttribute('open');
    });

    return {
      activateByMediaId: function (mediaId) {
        if (!mediaId) return false;
        var index = -1;
        slides.forEach(function (slide, i) {
          if (String(slide.getAttribute('data-media-id')) === String(mediaId)) index = i;
        });
        if (index < 0) return false;
        activate(index);
        return true;
      }
    };
  }

  function initVariantPicker(root, variants, galleryApi) {
    var form = root.querySelector('[data-mb-pdp-form]');
    var idInput = root.querySelector('[data-mb-pdp-variant-id]');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-mb-pdp-option]'));
    var priceEl = root.querySelector('[data-mb-pdp-price]');
    var compareEl = root.querySelector('[data-mb-pdp-compare]');
    var submit = root.querySelector('[data-mb-pdp-submit]');
    var stickySubmit = document.querySelector('[data-mb-pdp-sticky-submit]');
    var stickyPrice = document.querySelector('[data-mb-pdp-sticky-price]');
    var status = root.querySelector('[data-mb-pdp-status]');
    if (!form || !idInput) return;

    var selected = {};

    pills.forEach(function (pill) {
      var position = pill.dataset.optionPosition;
      if (position && pill.classList.contains('is-selected')) {
        selected[position] = pill.dataset.optionValue;
      }
      pill.addEventListener('click', function () {
        root.querySelectorAll('[data-mb-pdp-option][data-option-position="' + position + '"]').forEach(function (item) {
          item.classList.toggle('is-selected', item === pill);
        });
        selected[position] = pill.dataset.optionValue;
        updateVariant();
      });
    });

    function findVariant() {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          var key = String(index + 1);
          return !selected[key] || selected[key] === value;
        });
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      var buy = root.querySelector('[data-mb-pdp-buy]');
      var format = (buy && buy.getAttribute('data-mb-money-format')) || '{{amount}}';
      var value = (Math.abs(Number(cents)) / 100).toFixed(2);
      var grouped = value.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/g, grouped);
    }

    function setSubmitLabel(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      var labelEl = button.querySelector('[data-mb-pdp-submit-label]');
      var fallback = button.dataset.defaultLabel;
      if (labelEl) {
        if (!fallback) {
          button.dataset.defaultLabel = labelEl.textContent.trim();
          fallback = button.dataset.defaultLabel;
        }
        labelEl.textContent = disabled ? text.soldOut : fallback;
      }
    }

    function updateVariant() {
      var variant = findVariant() || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.hidden = true;
        }
      }
      var disabled = !variant.available;
      setSubmitLabel(submit, disabled);
      setSubmitLabel(stickySubmit, disabled);
      if (status) status.hidden = true;
      applyQtyRules(variant);
      if (galleryApi && variant.featured_media_id) {
        galleryApi.activateByMediaId(variant.featured_media_id);
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (err) {}
    }

    if (submit && !submit.dataset.defaultLabel) {
      var labelNode = submit.querySelector('[data-mb-pdp-submit-label]');
      submit.dataset.defaultLabel = (labelNode ? labelNode.textContent : submit.textContent).trim();
    }
    updateVariant();
  }

  function syncQuantity(value) {
    var next = String(clampQty(value));
    document.querySelectorAll('[data-mb-pdp-qty-input]').forEach(function (input) {
      input.value = next;
    });
    updateQtyButtons();
  }

  function initQuantity() {
    document.querySelectorAll('[data-mb-pdp-qty]').forEach(function (wrap) {
      if (wrap.dataset.mbQtyReady) return;
      wrap.dataset.mbQtyReady = '1';
      var input = wrap.querySelector('[data-mb-pdp-qty-input], .mb-pdp-buy__qty-input');
      if (!input) return;
      wrap.querySelector('[data-mb-pdp-qty-minus]')?.addEventListener('click', function () {
        syncQuantity((parseInt(input.value, 10) || qtyRules.min) - qtyRules.step);
      });
      wrap.querySelector('[data-mb-pdp-qty-plus]')?.addEventListener('click', function () {
        syncQuantity((parseInt(input.value, 10) || qtyRules.min) + qtyRules.step);
      });
      input.addEventListener('change', function () {
        syncQuantity(input.value);
      });
    });
  }

  function selectedVariantAvailable(root) {
    var idInput = root.querySelector('[data-mb-pdp-variant-id]');
    var variants = parseVariants(root);
    if (!idInput || !variants.length) return true;
    var match = variants.filter(function (variant) {
      return String(variant.id) === String(idInput.value);
    })[0];
    return match ? !!match.available : true;
  }

  function restoreSubmitState(root) {
    var submit = root.querySelector('[data-mb-pdp-submit]');
    var sticky = document.querySelector('[data-mb-pdp-sticky-submit]');
    var available = selectedVariantAvailable(root);
    if (submit) submit.disabled = !available;
    if (sticky) sticky.disabled = !available;
  }

  function syncHeaderCartCount(count) {
    if (typeof window.mirabaseUpdateCartCount === 'function') {
      window.mirabaseUpdateCartCount(count);
      return;
    }
    var link = document.querySelector('#cart-icon-bubble[data-mb-cart-count]');
    if (!link) return;
    var badge = link.querySelector('.mb-cart-count');
    var next = parseInt(count, 10) || 0;
    if (next > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mb-cart-count';
        link.appendChild(badge);
      }
      badge.textContent = String(next);
    } else if (badge) {
      badge.remove();
    }
  }

  function ensureDrawerSections(payload) {
    if (payload && payload.sections && payload.sections['cart-drawer']) {
      return Promise.resolve(payload);
    }
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '?sections=cart-drawer';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        payload.sections = payload.sections || {};
        if (sections && sections['cart-drawer']) {
          payload.sections['cart-drawer'] = sections['cart-drawer'];
        }
        return payload;
      })
      .catch(function () { return payload; });
  }

  function openCartDrawer(payload) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    if (!payload || !payload.sections || !payload.sections['cart-drawer']) return false;
    drawer.classList.remove('is-empty');
    if (typeof drawer.setActiveElement === 'function') {
      drawer.setActiveElement(document.activeElement);
    }
    drawer.renderContents(payload);
    return true;
  }

  function initProductForm(root) {
    var form = root.querySelector('[data-mb-pdp-form]');
    var submit = root.querySelector('[data-mb-pdp-submit]');
    var status = root.querySelector('[data-mb-pdp-status]');
    if (!form || form.dataset.mbCartWired) return;
    form.dataset.mbCartWired = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.dataset.mbAdding === '1') return;
      if (submit && submit.disabled) return;
      if (!form.dataset.ajax) {
        form.submit();
        return;
      }
      form.dataset.mbAdding = '1';
      if (submit) submit.disabled = true;
      var sticky = document.querySelector('[data-mb-pdp-sticky-submit]');
      if (sticky) sticky.disabled = true;
      if (status) {
        status.hidden = false;
        status.textContent = 'Adding...';
      }

      var drawer = document.querySelector('cart-drawer');
      var formData = new FormData(form);
      var sectionIds = 'cart-drawer';
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        var ids = drawer.getSectionsToRender().map(function (section) { return section.id; }).filter(Boolean);
        if (ids.length) sectionIds = ids.join(',');
      }
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);

      var addUrl = (window.routes && window.routes.cart_add_url) || form.action || '/cart/add';
      var headers = { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };

      fetch(addUrl, {
        method: 'POST',
        headers: headers,
        body: formData
      }).then(function (response) {
        return response.text().then(function (body) {
          var payload = {};
          try {
            payload = JSON.parse(body);
          } catch (err) {
            throw new Error(text.failed);
          }
          payload._httpOk = response.ok;
          return payload;
        });
      }).then(function (payload) {
        if (payload.status || payload.errors || payload._httpOk === false) {
          throw new Error(payload.description || payload.message || text.failed);
        }
        return ensureDrawerSections(payload).then(function (ready) {
          openCartDrawer(ready);
          document.dispatchEvent(new CustomEvent('mirabase:cart-added', { detail: ready }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mb-pdp',
              productVariantId: formData.get('id'),
              cartData: ready
            });
          }
          if (status) status.textContent = text.added;
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              syncHeaderCartCount(cart.item_count);
              var liveDrawer = document.querySelector('cart-drawer');
              if (liveDrawer) liveDrawer.classList.toggle('is-empty', !cart.item_count);
            })
            .catch(function () {});
        });
      }).catch(function (error) {
        if (status) status.textContent = (error && error.message) || text.failed;
      }).finally(function () {
        form.dataset.mbAdding = '';
        restoreSubmitState(root);
      });
    });
  }

  function initStickyBuy(root) {
    var bar = document.querySelector('[data-mb-pdp-sticky]');
    var buyRow = root.querySelector('.mb-pdp-buy__actions');
    var form = root.querySelector('[data-mb-pdp-form]');
    if (!bar || !buyRow || !form) return;
    var update = function () {
      var visible = buyRow.getBoundingClientRect().bottom < 0;
      bar.hidden = !visible;
      bar.classList.toggle('is-visible', visible);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    bar.querySelector('[data-mb-pdp-sticky-submit]')?.addEventListener('click', function () {
      form.requestSubmit();
    });
  }

  function initRails() {
    document.querySelectorAll('[data-mb-pdp-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-mb-pdp-rail-track]');
      if (!track) return;
      var section = rail.closest('.mb-pdp-related, .mb-pdp-ritual');
      section?.querySelector('[data-mb-pdp-related-prev]')?.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.85, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
      section?.querySelector('[data-mb-pdp-related-next]')?.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.85, behavior: reducedMotion ? 'auto' : 'smooth' });
      });
    });
  }

  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\u0E00-\u0E7F\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 48);
  }

  function isDescriptionHeading(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName.toLowerCase();
    if (tag === 'h2' || tag === 'h3') return true;
    if (tag !== 'p') return false;
    var text = el.textContent.trim();
    if (!text || text.length > 72 || text.indexOf('•') === 0) return false;
    if (el.querySelector('strong, b')) return true;
    return el.children.length === 0 && text.length < 48;
  }

  function initDescriptionSections() {
    var body = document.querySelector('[data-mb-pdp-description-body]');
    var tocList = document.querySelector('[data-mb-pdp-toc-list]');
    if (!body) return;

    var nodes = Array.prototype.slice.call(body.childNodes).filter(function (node) {
      return node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim());
    });
    if (!nodes.length) return;

    var sections = [];
    var current = { title: null, nodes: [] };

    function flush() {
      if (current.title || current.nodes.length) sections.push(current);
      current = { title: null, nodes: [] };
    }

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && isDescriptionHeading(node)) {
        flush();
        current.title = node;
      } else {
        current.nodes.push(node);
      }
    });
    flush();

    if (sections.length <= 1 && !sections[0].title) return;

    var fragment = document.createDocumentFragment();
    sections.forEach(function (section, index) {
      var wrap = document.createElement('div');
      wrap.className = 'mb-pdp-description__section';

      if (section.title) {
        var heading = section.title;
        heading.classList.add('mb-pdp-description__section-title');
        var id = 'pdp-section-' + (slugify(heading.textContent) || String(index));
        heading.id = id;
        wrap.appendChild(heading);

        if (tocList) {
          var li = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + id;
          link.textContent = heading.textContent.trim();
          link.dataset.mbPdpTocLink = '';
          li.appendChild(link);
          tocList.appendChild(li);
        }
      }

      section.nodes.forEach(function (node) {
        wrap.appendChild(node);
      });
      fragment.appendChild(wrap);
    });

    body.innerHTML = '';
    body.appendChild(fragment);
  }

  function initSubnav() {
    var subnav = document.querySelector('[data-mb-pdp-subnav]');
    if (!subnav) return;

    var links = Array.prototype.slice.call(subnav.querySelectorAll('[data-mb-pdp-subnav-link]'));
    var targets = links.map(function (link) {
      var id = link.getAttribute('href');
      return id ? document.querySelector(id) : null;
    }).filter(Boolean);

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    var tocLinks = Array.prototype.slice.call(document.querySelectorAll('[data-mb-pdp-toc-link]'));
    var onScroll = function () {
      var scrollY = window.scrollY + calcOffset();
      var activeId = null;

      targets.forEach(function (target) {
        if (target.offsetTop <= scrollY) activeId = target.id;
      });

      links.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        link.classList.toggle('is-active', href === '#' + activeId);
      });

      tocLinks.forEach(function (link) {
        var section = document.querySelector(link.getAttribute('href'));
        if (!section) return;
        link.classList.toggle('is-active', section.offsetTop <= scrollY && section.offsetTop + section.offsetHeight > scrollY);
      });
    };

    function calcOffset() {
      var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      var subnavH = subnav.offsetHeight || 48;
      return (header || 72) + subnavH + 16;
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initIngredientsDialog() {
    var dialog = document.querySelector('[data-mb-pdp-ingredients-dialog]');
    document.querySelector('[data-mb-pdp-ingredients-open]')?.addEventListener('click', function () {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    document.querySelector('[data-mb-pdp-ingredients-close]')?.addEventListener('click', function () {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mb-pdp-root]').forEach(function (root) {
      root.classList.add('is-revealed');
      var variants = parseVariants(root);
      var galleryApi = initGallery(root);
      initQuantity();
      initVariantPicker(root, variants, galleryApi);
      initProductForm(root);
      initStickyBuy(root);
    });
    initRails();
    initIngredientsDialog();
    initDescriptionSections();
    initSubnav();
  });
})();
